import { request } from '@/api/httpClient'

export async function companyGetCompanyHolidays() {
  return request({
    method: 'company/GetCompanyHolidays'
  })
}

export async function companyAddCompanyHoliday(title, dateStart, dateEnd) {
  await request({
    method: 'company/AddCompanyHoliday',
    payload: {
      Title: title,
      DateStart: dateStart,
      DateEnd: dateEnd
    }
  })
}

export async function companyUpdateCompanyHoliday(id, title, dateStart, dateEnd) {
  await request({
    method: 'company/UpdateCompanyHoliday',
    payload: {
      Id: id,
      Title: title,
      DateStart: dateStart,
      DateEnd: dateEnd
    }
  })
}

export async function companyDeleteCompanyHoliday(id) {
  await request({
    method: 'company/DeleteCompanyHoliday',
    payload: { Id: id }
  })
}

export async function companyGetUserDetails() {
  return request({
    method: 'company/GetUserDetails'
  })
}

export async function companyGetListCompanies(CompanyType) {
  return request({
    method: 'company/ListCompanies',
    payload: { CompanyType }
  })
}

export async function companyGetOrganisation(companyId) {
  return request({
    method: 'company/GetOrganisation',
    payload: { companyId }
  })
}

export async function companyUpdateOrganisation(organisation) {
  return request({
    method: 'company/UpdateOrganisation',
    payload: organisation
  })
}
